import React from 'react';
import { addFilter } from '../../common/services/navigation';
import SearchInput from '../../common/components/_SearchBox';


function JobKnowledgeListerTopComponent({ search, filters, settings }) {
    
    return (

        <div className="filter-bar faq large-12">
            <div className="filter__text">
                Filter by keyword
            </div>

            <SearchInput search={search} settings={settings}/>	 

        </div>
	);
}

export default JobKnowledgeListerTopComponent;
